import axios from 'axios';
import { BASE_URL } from './Config';
import Utils from './Utils';

const AxiosInstance = axios.create({
  baseURL: BASE_URL,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
});

const clearToken = () => {
  Utils.RemoveStorage('accessToken');
  Utils.RemoveStorage('refreshToken');
};

let refreshingToken = null;

// 요청 인터셉터 추가
AxiosInstance.interceptors.request.use(
  async (config) => {
    // console.log('interceptors request config', config);
    let accessToken = Utils.GetStorage('accessToken');
    // console.log('accessToken', accessToken);
    if (accessToken) {
      config.headers['X-AUTH-TOKEN'] = accessToken;
    }

    return config;
  },
  (error) => {
    console.log('interceptors request error', error);

    return Promise.reject(error);
  },
);

// 응답 인터셉터 추가
AxiosInstance.interceptors.response.use(
  (response) => {
    // console.log('interceptors response', response);
    return response.data;
  },
  async (error) => {
    console.log('axios error', error);

    // 응답 자체가 없는 경우(네트워크 단절, CORS 차단, nginx 413 등)는 인증 만료가 아니다.
    // 토큰을 지우고 로그인으로 보내면 업로드 용량 초과 같은 상황에서 세션이 끊긴다.
    if (!error.response) {
      return Promise.reject({
        status: 0, // 응답 없음(네트워크/CORS 차단)
        data: { message: '요청을 처리하지 못했습니다. 네트워크 상태를 확인한 뒤 다시 시도해주세요.' },
      });
    }

    const prevRequest = error.config;
    const refreshTokenMessage = error.response?.data?.message;

    if (
      (refreshTokenMessage === 'Refresh JWT 토큰형식이 일치하지 않습니다.' ||
        refreshTokenMessage === 'Refresh 토큰이 입력되지 않았습니다.') &&
      !prevRequest?.sent
    ) {
      prevRequest.sent = true;

      if (!refreshingToken) {
        refreshingToken = Utils.reissueAccessToken(); // 토큰 갱신 요청 시작
      }

      try {
        await refreshingToken; // 기존에 진행 중인 토큰 갱신을 기다림

        return AxiosInstance(prevRequest);
      } catch (err) {
        clearToken();

        return Promise.reject(err.response);
      } finally {
        refreshingToken = null; // 토큰 갱신 완료 후 변수 초기화
      }
    } else if (
      refreshTokenMessage === 'Refresh 토큰 인증이 만료되었습니다.' ||
      refreshTokenMessage === '존재하지 않는 Refresh JWT 입니다. 다시 로그인 해주세요.'
    ) {
      alert('세션이 만료되었습니다. 다시 로그인해주세요.');
      clearToken();
      window.location.href = '/login';
    }
    console.log('interceptors response error', error);

    return Promise.reject(error.response);
  },
);

export default AxiosInstance;
